import { render } from "./iconDisplay.vue?vue&type=template&id=5f80171a&scoped=true"
import script from "./iconDisplay.vue?vue&type=script&lang=js"
export * from "./iconDisplay.vue?vue&type=script&lang=js"

import "./iconDisplay.vue?vue&type=style&index=0&id=5f80171a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f80171a"]])

export default __exports__